import {Component, OnDestroy, OnInit, Input} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventManager, AccountService } from 'src/app/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { EditComponent } from 'src/app/shared/components/edit.component';
import { ToastrService } from 'ngx-toastr';
import { ProductService } from '../../product.service';
import { DividendModel } from 'src/app/modules/master-data/components/models/dividend.model';
import { ParseDataService } from '../../services/parseData.service';
import { Constant } from 'src/app/core/constant';
import { AppQueries } from 'src/app/state';

@Component({
  selector: 'app-edit-dividend',
  templateUrl: './edit-dividend.component.html',
  styleUrls: ['./edit-dividend.component.scss']
})
export class EditDividendComponent extends EditComponent implements OnInit {
  errors: any;
  editForm = this.fb.group({
    dividendAmt: [0, [Validators.required]],
    dividendDate: [null, [Validators.required]],
    paymentDate: [null],
    exDividendDate: [null],
    productId: [undefined, [Validators.required]],
  });
  Constant = Constant;
  funds: any[];
  detailObject: DividendModel = new DividendModel();
  classModel = DividendModel;
  constructor(
    private fb: FormBuilder,
    public eventManager: EventManager,
    private productService: ProductService,
    public router: Router,
    public route: ActivatedRoute,
    private appQueries: AppQueries,
    public toast: ToastrService
  ) {
    super(eventManager, route);
  }
  ngOnInit() {
    super.ngOnInit();
    this.subscriptions.push(
      this.appQueries.products$
      .subscribe((products) => {
        this.funds = products || [];
      }),
    );
  }
  getDetail() {
    this.productService
      .findProductDividend(this.id)
      .subscribe(this.onResponse.bind(this));
  }
  updateForm() {
    this.isSaved = false;
    const body: any = {
      dividendAmt: this.detailObject.dividendAmt,
      dividendDate: this.detailObject.dividendDate,
      paymentDate: this.detailObject.paymentDate,
      exDividendDate: this.detailObject.exDividendDate,
      productId: (this.detailObject.productId || {}).id,
    };
    this.editForm.patchValue(body);
  }
  disabledButton() {
    if (!this.editForm.get('dividendDate').value) {
      this.errors.dividendDate = true;
    } else {
      this.errors.dividendDate = false;
    }
    const amount = this.editForm.get('dividendAmt').value;
    if (amount > 0) {
      this.errors.amount = false;
    } else {
      this.errors.amount = true;
    }
    return super.disabledButton();
  }
  save() {
    this.isSaved =  true;
    if (this.disabledButton() || this.editForm.invalid) {
      return;
    }
    const holiday = {
      id: this.detailObject.id || undefined,
      dividendAmt: this.editForm.get('dividendAmt').value,
      dividendDate: this.editForm.get('dividendDate').value,
      paymentDate: this.editForm.get('paymentDate').value,
      exDividendDate: this.editForm.get('exDividendDate').value,
      productId: this.editForm.get('productId').value,
    };
    const type = !this.detailObject.id ? 'saveProductDividend' : 'updateProductDividend';
    this.productService[type](holiday)
    .subscribe(
      (rs: HttpResponse<any>) => {
        this.isSaved = false;
        if (this.detailObject.id) {
          this.toast.success('Update Successfully');
        } else {
          this.detailObject = new DividendModel();
          this.updateForm();
          this.toast.success('Create Successfully');
        }
        this.router.navigate(['/products/dividend']);
      }
    );
  }
}
